var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{staticClass:"list_page",attrs:{"current":_vm.params.pageNum,"page-size":_vm.params.pageSize,"total":_vm.total,"show-total":true,"show-elevator":"","show-sizer":"","prev-text":"<<上一页","next-text":"下一页>>"},on:{"on-change":_vm.changePage,"on-page-size-change":_vm.changePageSize}})
}
var staticRenderFns = []

export { render, staticRenderFns }